import * as types from './types';
import API from '../../utils/api';
import { ENDPOINT_URL } from '../../constants/defaultValues';
import DeviceService from '../../services/DeviceService';
import {
    AUTH_AUTHENTICATED_CHANGED,
    AUTH_AUTHENTICATING_CHANGED,
    AUTH_CASHIER_INFO_CHANGED,
} from './types';
import { logout } from '../../utils/helpers';

export const loginDevice = () => async dispatch => {
    try {
        dispatch(setAuthenticating(true));

        const macAddress = await getMacAddress();

        if (!macAddress) {
            dispatch(setAuthenticating(false));
            logout();
            return;
        }

        sessionStorage.setItem('macAddress', macAddress);

        const { info } = await dispatch(getProfile());

        if (!info.success) {
            dispatch(setAuthenticating(false));
            logout();
            return;
        }

        dispatch(setAuthenticated(true));
    } catch (error) {
        console.error(error);
        dispatch(setAuthenticating(false));
    }
};

export const getProfile = () => async dispatch => {
    try {
        const response = await API.get(`${ENDPOINT_URL}/cashier/profile`);

        const { info, item: cashierInfo } = response.data;

        if (!info.success) {
            return;
        }

        dispatch(setCashierInfo(cashierInfo));
        dispatch({
            type: types.CHANGE_BET_STAKE_LIMITS,
            payload: {
                sportMinimum: cashierInfo.minBettingStakeAmount,
                eSportMinimum: cashierInfo.minBettingStakeAmountForESport,
            },
        });

        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const setAuthenticating = payload => ({
    type: AUTH_AUTHENTICATING_CHANGED,
    payload,
});

export const setAuthenticated = payload => ({
    type: AUTH_AUTHENTICATED_CHANGED,
    payload,
});

export const setCashierInfo = cashier => ({
    type: AUTH_CASHIER_INFO_CHANGED,
    payload: cashier,
});

const getMacAddress = async () => {
    const response = await DeviceService.getDeviceMacAddress();

    let macAddress = response?.data?.macAddress;

    return macAddress;
};
